import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem/SliderListItem';
import { shakeAmountToIntensity } from '../../../Preview/PreviewDisplayConstants';

const VisualizerShakeListItem = (props) => {
    const { intensity, updateVisualizerSettings } = props;

    const onIntensityChange = useCallback((value) => {
        if (value === intensity) return;
        updateVisualizerSettings({ shakeIntensity: value });
    }, [intensity, updateVisualizerSettings]);

    return (
        <SliderListItem
            title='Rumble'
            displayMultiplier={1}
            value={intensity}
            min={0}
            max={100}
            step={1}
            onValueChange={onIntensityChange}
            toolTip={'How much the visualizer shakes back and forth during loud audio.'}
        />
    );
};

const mapStateToProps = (state) => {
    const { shakeIntensity, shakeAmount } = state.createPreview.present.videoSettings.visualizer;
    return {
        intensity: shakeIntensity ?? shakeAmountToIntensity(shakeAmount)
    };
};

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerShakeListItem);
